var _mask, _path, _mask2, _path2, _mask3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuantity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4134_101490",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 10.3431 2.34315 9 4 9H5C6.65685 9 8 10.3431 8 12V13C8 14.6569 6.65685 16 5 16H4C2.34315 16 1 14.6569 1 13V12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5H5V7.5H4V10.5ZM6.5 12V13H9.5V12H6.5ZM5 14.5H4V17.5H5V14.5ZM2.5 13V12H-0.5V13H2.5ZM4 14.5C3.17157 14.5 2.5 13.8284 2.5 13H-0.5C-0.5 15.4853 1.51472 17.5 4 17.5V14.5ZM6.5 13C6.5 13.8284 5.82843 14.5 5 14.5V17.5C7.48528 17.5 9.5 15.4853 9.5 13H6.5ZM5 10.5C5.82843 10.5 6.5 11.1716 6.5 12H9.5C9.5 9.51472 7.48528 7.5 5 7.5V10.5ZM4 7.5C1.51472 7.5 -0.5 9.51472 -0.5 12H2.5C2.5 11.1716 3.17157 10.5 4 10.5V7.5Z",
    fill: "#197C85",
    mask: "url(#path-1-inside-1_4134_101490)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_4134_101490",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3C8 1.34315 9.34315 0 11 0H13C14.6569 0 16 1.34315 16 3V5C16 6.65685 14.6569 8 13 8H11C9.34315 8 8 6.65685 8 5V3Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5H13V-1.5H11V1.5ZM14.5 3V5H17.5V3H14.5ZM13 6.5H11V9.5H13V6.5ZM9.5 5V3H6.5V5H9.5ZM11 6.5C10.1716 6.5 9.5 5.82843 9.5 5H6.5C6.5 7.48528 8.51472 9.5 11 9.5V6.5ZM14.5 5C14.5 5.82843 13.8284 6.5 13 6.5V9.5C15.4853 9.5 17.5 7.48528 17.5 5H14.5ZM13 1.5C13.8284 1.5 14.5 2.17157 14.5 3H17.5C17.5 0.514719 15.4853 -1.5 13 -1.5V1.5ZM11 -1.5C8.51472 -1.5 6.5 0.514719 6.5 3H9.5C9.5 2.17157 10.1716 1.5 11 1.5V-1.5Z",
    fill: "#197C85",
    mask: "url(#path-3-inside-2_4134_101490)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_4134_101490",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 13C10 11.3431 11.3431 10 13 10H17C18.6569 10 20 11.3431 20 13V17C20 18.6569 18.6569 20 17 20H13C11.3431 20 10 18.6569 10 17V13Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.5H17V8.5H13V11.5ZM18.5 13V17H21.5V13H18.5ZM17 18.5H13V21.5H17V18.5ZM11.5 17V13H8.5V17H11.5ZM13 18.5C12.1716 18.5 11.5 17.8284 11.5 17H8.5C8.5 19.4853 10.5147 21.5 13 21.5V18.5ZM18.5 17C18.5 17.8284 17.8284 18.5 17 18.5V21.5C19.4853 21.5 21.5 19.4853 21.5 17H18.5ZM17 11.5C17.8284 11.5 18.5 12.1716 18.5 13H21.5C21.5 10.5147 19.4853 8.5 17 8.5V11.5ZM13 8.5C10.5147 8.5 8.5 10.5147 8.5 13H11.5C11.5 12.1716 12.1716 11.5 13 11.5V8.5Z",
    fill: "#197C85",
    mask: "url(#path-5-inside-3_4134_101490)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantity);
export default __webpack_public_path__ + "static/media/quantity.e937c4c51de779055e07c27602a8b7c2.svg";
export { ForwardRef as ReactComponent };